import axios from "../Config/axiosConfig";
import { serialize } from "../Utils/utils";
const urlApi = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

async function get(path, data = null, config) {
  let queryParams = ''
  if(data){
    queryParams = '?'+serialize({ ...data });
  }
  var promise = axios.get(`${urlApi}/${path}${queryParams}`, config);
  return await promise;
}

async function post(path, data, config) {
  var promise = axios.post(`${urlApi}/${path}`, data, config);
  return await promise;
}

async function put(path, data) {
  var promise = axios.put(`${urlApi}/${path}`, data);
  return await promise;
}

async function deletar(path, data) {
  var promise = axios.delete(`${urlApi}/${path}`, data);
  return await promise;
}

const baseApi = { get, post, put, deletar };

export default baseApi;
